import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./App.css";

import RouteAll from "./routes/RouteAll";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { MinimumPercentProvider } from "./utilities/MinimumPercentContext";
import { useSettings } from "./context/SettingsContext";
import { fetchUser } from "./redux/slices/profileSlice";
import { USER_UPDATED_EVENT, refreshCurrentUser } from "./utilities/currentUser";

function App() {
  const { globalSettings } = useSettings();
  const dispatch = useDispatch();

  // Roles are stored at login and change on the server (approvals, admin edits): refresh them on
  // app load and when the tab regains focus (refreshCurrentUser throttles to once per minute).
  useEffect(() => {
    const syncStore = () => dispatch(fetchUser());
    const onFocus = () => refreshCurrentUser();
    const onVisible = () => {
      if (document.visibilityState === "visible") refreshCurrentUser();
    };

    window.addEventListener(USER_UPDATED_EVENT, syncStore);
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    refreshCurrentUser({ force: true });

    return () => {
      window.removeEventListener(USER_UPDATED_EVENT, syncStore);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [dispatch]);

  useEffect(() => {
    
    if (globalSettings) {
      
      if (globalSettings.primaryColor) {
        document.documentElement.style.setProperty('--primary', globalSettings.primaryColor);
        
        document.documentElement.style.setProperty('--primary-soft', `${globalSettings.primaryColor}1a`);
      }

      // Secondary Color Update
      if (globalSettings.secondaryColor) {
        document.documentElement.style.setProperty('--secondary', globalSettings.secondaryColor);
      }
    }
  }, [globalSettings]);

  return (
    <MinimumPercentProvider>
      <BrowserRouter>
        <RouteAll />
      </BrowserRouter>
    </MinimumPercentProvider>
  );
}

export default App;